export default "__VITE_ASSET__b04dbb66__"